import Notification from './Notification';
export default Notification;



// WEBPACK FOOTER //
// ./_rc-notification-3.0.0/src/index.js